import { findShareInfoApi, shareFilePageApi } from '@/api/copyright/drama'
import tableConfig from '@/config/copyright/tableConfig'
export default {
    data () {
        return {
            show: false,
            tableData: [],
            pageSizes: tableConfig.pageSizes,
            condition: {
                page: 1,
                size: tableConfig.pageSize,
            },
            dramaId: null,
            total: 0,
            multipleSelection: [],
            rightsInfo: {},
            basicInfo: {},
            certificateInfo: {},
            shareLink: ''
        }
    },
    methods: {
        
        tableApi () {
            this.$TsaLoadingV2.show()
            shareFilePageApi({
                page: this.condition.page,
                size: this.condition.size,
                dramaId: this.dramaId,
            }).then(({ code, data={}, message}) => {
                this.$TsaLoadingV2.hide()
                if (code === 200) {
                    this.total = data.total || 0
                    let array = data.data || []
                    array.map(item => {
                        // 获取已存在的数据
                        let obj = this.multipleSelection.find(item1 => item1.id === item.id)
                        if (obj) {
                            item.checked = obj.checked
                            item.viewPermission = obj.viewPermission
                            item.downloadFilePermission = obj.downloadFilePermission
                            item.downloadPdfPermission = obj.downloadPdfPermission
                        } else {
                            item.checked = false
                        }
                       
                    })
                    this.tableData = array
                }
                
            }).catch(() => {
                this.$TsaLoadingV2.hide()
            })
        },
        currentChange (val) {
            this.condition.page = val
            this.tableApi()
        },
        handleSizeChange (val) {
            this.condition.page = 1
            this.condition.size = val
            this.tableApi()
        },
        
    }
}